module.exports = __webpack_public_path__ + "static/media/carbon_pin_outline.fc9f3243.svg";